enum TriggerEventName {
  FirstLoad = 'first-load',
  PreCheckout = 'pre-checkout',
  CartView = 'cart-view',
  ViewItem = 'view-item',
  ViewModGroup = 'view-mod-group',
}

enum VitrineTriggerEventName {
  FirstLoad = TriggerEventName.FirstLoad,
  CartView = TriggerEventName.CartView,
  ViewItem = TriggerEventName.ViewItem,
  ViewModGroup = TriggerEventName.ViewModGroup,
  PreCheckout = TriggerEventName.PreCheckout,
  MenuSectionRecommendation = 'menu-section-recommendation',
}

export { TriggerEventName, VitrineTriggerEventName };
